import { PropsWithChildren } from 'react';

import { Typography } from '@mui/material';

import BaseLoading from '@/components/Loading';

import { EmptyStateContainer } from '../../styled';

function EmptyState({ children }: PropsWithChildren<{}>) {
  return (
    <EmptyStateContainer>
      <Typography variant="h5" color="text.muted">
        {children}
      </Typography>
    </EmptyStateContainer>
  );
}

function Loading() {
  return (
    <EmptyState>
      <BaseLoading />
    </EmptyState>
  );
}

export { Loading };
export default EmptyState;
